import { downloadImageAsBase64 } from './downloadImageAsBase64';

export const urlRegex = /url\(['"]?([^'"()]+)['"]?\)/g;

export const replaceCssWithBase64 = async (
  node: HTMLElement
): Promise<void> => {
  const nodes = [node, ...node.querySelectorAll<HTMLElement>('*')];

  // Process inline styles
  await Promise.all(
    nodes.map(async node => {
      const backgroundImage = node.style?.backgroundImage
        ?.slice(4, -1)
        .replace(/"/g, '');

      if (!backgroundImage) return;

      try {
        const base64 = await downloadImageAsBase64(backgroundImage);
        node.style.backgroundImage = `url(${base64})`;
      } catch (error) {
        // console.error(`Failed to convert background image to base64: ${error}`);
      }
    })
  );

  // Process style tags
  const styleTags = Array.from(
    node.querySelectorAll<HTMLStyleElement>('style')
  );
  await Promise.all(
    styleTags.map(async (styleTag: HTMLStyleElement) => {
      const cssText = styleTag.textContent || '';
      let match;
      let newCssText = cssText;
      // Create a new RegExp instance for each style tag to prevent state interference
      const styleRegex = new RegExp(urlRegex.source, urlRegex.flags);

      while ((match = styleRegex.exec(cssText)) !== null) {
        const url = match[1];

        if (url.startsWith('data:')) {
          continue;
        }

        try {
          const base64 = await downloadImageAsBase64(url);
          newCssText = newCssText.replace(match[0], `url(${base64})`);
        } catch (error) {
          // console.error(
          //   `Failed to convert URL to base64 in style tag: ${error}`
          // );
        }
      }

      styleTag.textContent = newCssText;
    })
  );
};
